// This file contains the API calls to the Netlify function
export const dailyQuote = async () => {
  const response = await fetch('/.netlify/functions/dailyQuote')
  return await response.json()
}
